import { ROUTES } from "../../../api/api.routes";
import useCustomQuery from "../../../hooks/useQuery";
import { Doc, Model, Sorted } from "../../../types";

/** A model as Anthropic reports it, i.e. what a custom model can wrap. */
export interface ExternalModelInfo {
  id: string;
  display_name: string;
  max_input_tokens: number | null;

  max_tokens: number | null;
  type: 'model';
}

export const useModels = () => {
  const {
    data,
    isLoading,
    mutate,
    ...rest
  } = useCustomQuery<Sorted<Doc<Model>>>(ROUTES.Models.All.route);

  return {
    models: data?.items ?? [],
    modelsById: data?.byId ?? {},
    loadingModels: isLoading,
    reloadModels: mutate,
    ...rest
  }
}

export const useExternalModels = () => {
  const {
    data,
    isLoading,
    mutate,
    ...rest
  } = useCustomQuery<ExternalModelInfo[]>(ROUTES.Models.External);

  return {
    externalModels: data ?? [],
    loadingExternalModels: isLoading,
    reloadExternalModels: mutate,
    ...rest
  }
}
